import React from 'react'
import Lottie from 'react-lottie'

import { Mask } from '@/elements'

import animationData from './preloader_2.json'
import { zIndexLevel } from '@/utils'

const options = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
}

const Loader = () => (
    <Mask
        data-name="loader"
        background="rgba(255,255,255,0.7)"
        zIndex={zIndexLevel.L13}
    >
        <Lottie options={options} height="80px" width="80px" />
    </Mask>
)

export { Loader }
